exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".m_row{padding:20px 0}.cat_subtitle{color:red}#vegan-friendly-icon{width:1.5rem;-webkit-transform:translateY(-.3rem);-moz-transform:translateY(-.3rem);-ms-transform:translateY(-.3rem);transform:translateY(-.3rem)}.cat-black .side_title{color:#bbb}.cat-black .pop_filters_m .filter_check.active a{color:#ea4725}.category_top_banner .white-text .text,.category_top_banner .white-text .title{color:#fff}", ""]);

// exports
